"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meaningSynonyms = exports.meaningSynonymText = exports.meaningDetailSources = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var meaningSynonyms = exports.meaningSynonyms = function meaningSynonyms(meaning, synonymOverride) {
  var synonyms = (meaning === null || meaning === void 0 ? void 0 : meaning.synonyms) || [];
  return synonymOverride ? [synonymOverride].concat(_toConsumableArray(synonyms.filter(function (synonym) {
    return String(synonym.id) !== String(synonymOverride.id);
  }))) : synonyms;
};
var meaningSynonymText = exports.meaningSynonymText = function meaningSynonymText(synonyms, expanded, dictionarySentences) {
  var truncate = !expanded || dictionarySentences;
  var displayed = truncate ? synonyms.slice(0, 2) : synonyms;
  var text = displayed.map(function (synonym) {
    return synonym.targetTextWithDefiniteArticle || synonym.targetText;
  }).join(', ');
  return "".concat(text).concat(truncate && synonyms.length > 2 ? '…' : '');
};
var meaningDetailSources = exports.meaningDetailSources = function meaningDetailSources(translationSources, synonyms, languageId, _onPress) {
  return translationSources.concat(synonyms.map(function (synonym) {
    return {
      id: "synonym-".concat(synonym.id),
      onPress: function onPress() {
        return _onPress(synonym);
      },
      source: {
        languageId: languageId,
        textForUser: function textForUser() {
          return synonym.targetTextWithDefiniteArticle || synonym.targetText;
        }
      }
    };
  }));
};